import { ContractingParty } from '@faire/web-api--source/com/faire/terms_of_service/ContractingParty';
import { TermsOfServiceType } from '@faire/web-api--source/com/faire/terms_of_service/TermsOfServiceType';
import { ILocaleKey } from '@faire/web-api--source/indigofair/locale/ILocaleKey';

export namespace ITermsOfServiceArticle {
  /**
   * Return an instance of ITermsOfServiceArticle with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ITermsOfServiceArticle>
  ): ITermsOfServiceArticle =>
    ({
      ...(partial ?? {}),
    }) as ITermsOfServiceArticle;
}

export interface ITermsOfServiceArticle {
  type: keyof typeof TermsOfServiceType | undefined;
  contracting_party: keyof typeof ContractingParty | undefined;
  id: string | undefined;
  /**
   * @deprecated
   */
  locale_key: ILocaleKey | undefined;
  updated_at: number | undefined;
  /**
   * locale of the Zendesk article, not necessarily same as user's locale
   */
  zendesk_locale: string | undefined;
}
